import { useContext } from "react";
import NotesContext from "../contexts/NotesContext";

export const useNote = () => {
  return useContext(NotesContext);
};
